"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoNotFullOpenIcon = createIcon({
  displayName: "CompRegoNotFullOpenIcon",
  viewBox: "0 0 45 33.53",
  path: (
    <>
      <path
        d="M36.63,18.88v-4.19h-4.19v-4.19h4.19v-4.19h4.19v4.19h4.19v4.19h-4.19v4.19h-4.19ZM16.74,16.79c-2.3,0-4.27-.82-5.92-2.47-1.63-1.63-2.47-3.62-2.47-5.92s.82-4.27,2.47-5.92c1.65-1.65,3.62-2.47,5.92-2.47s4.27.82,5.92,2.47c1.65,1.65,2.47,3.62,2.47,5.92s-.82,4.27-2.47,5.92c-1.63,1.63-3.62,2.47-5.92,2.47ZM0,33.53v-5.86c0-1.19.31-2.28.92-3.27.61-1,1.42-1.76,2.43-2.28,2.16-1.09,4.35-1.88,6.59-2.43,2.24-.54,4.5-.82,6.8-.82s4.56.27,6.8.82c2.24.54,4.44,1.36,6.59,2.43,1,.52,1.82,1.28,2.43,2.28.61,1,.92,2.09.92,3.27v5.86H0ZM16.74,12.6c1.15,0,2.13-.42,2.95-1.23.82-.82,1.23-1.8,1.23-2.95s-.42-2.13-1.23-2.95c-.82-.82-1.8-1.23-2.95-1.23s-2.13.42-2.95,1.23c-.82.82-1.23,1.8-1.23,2.95s.42,2.13,1.23,2.95c.82.82,1.8,1.23,2.95,1.23ZM4.19,29.34h25.12v-1.67c0-.38-.1-.73-.29-1.05-.19-.31-.44-.57-.75-.73-1.88-.94-3.79-1.65-5.71-2.11-1.93-.46-3.85-.71-5.82-.71s-3.89.23-5.82.71c-1.93.48-3.83,1.17-5.71,2.11-.31.17-.57.42-.75.73-.19.31-.29.67-.29,1.05v1.67h.04Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default CompRegoNotFullOpenIcon;
